var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepsSep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 125,
    height: 5,
    viewBox: "0 0 125 5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 5,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u041F\\u043E\\u0432\\u0442\\u043E\\u0440\\u044F\\u044E\\u0449\\u0430\\u044F\\u0441\\u044F_\\u0441\\u0435\\u0442\\u043A\\u0430_1",
    "data-name": "\\u041F\\u043E\\u0432\\u0442\\u043E\\u0440\\u044F\\u044E\\u0449\\u0430\\u044F\\u0441\\u044F \\u0441\\u0435\\u0442\\u043A\\u0430 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_982",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 982",
    transform: "translate(-398 -803)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_101",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 101",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(398 803)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_107",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 107",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(470 803)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_102",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 102",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(422 803)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_109",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 109",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(494 803)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_103",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 103",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(446 803)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_113",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 113",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(518 803)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_104",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 104",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(410 803)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_108",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 108",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(482 803)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_105",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 105",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(434 803)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_114",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 114",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(506 803)",
    fill: "#d19f46"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_106",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 106",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(458 803)",
    fill: "#d19f46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepsSep);
export default __webpack_public_path__ + "static/media/steps_sep.06c49d89e05527f9df6e149b699d63ab.svg";
export { ForwardRef as ReactComponent };